import React from "react"
import Heading from "../../common/Heading"
import "./recent.css"
import RecentCard from "./RecentCard"

const Recent = () => {
  return (
    <>
      <section className='recent padding'>
        <div className='container'>
        <Heading title={"Our Extensive Collection of Decoration Styles"} subtitle=
              {"Discover a wide range of themes to suit every taste and preference. We've got you covered for any occasion!"} />
          <RecentCard />
        </div>
      </section>
    </>
  )
}

export default Recent
// Where Memories Are Made: Get Inspired by Our Latest Decor and Catering Creations. 
// Explore our latest collection and get ready to make your next celebration unforgettable!"
